export enum EWidgetRegion {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
